(function () {

  'use strict';


  /* =========================================================
     COLLECTION INITIALIZATION
  ========================================================= */

  function initCustomCollection(section) {

    if (!section) return;

    if (section.dataset.customCollectionInitialized === 'true') {
      return;
    }

    section.dataset.customCollectionInitialized = 'true';


    /* =========================================================
       ELEMENTS
    ========================================================= */

    const productsGrid =
      section.querySelector('#CustomProductGrid');

    const filterDrawer =
      section.querySelector('[data-filter-drawer]');

    const sortDrawer =
      section.querySelector('[data-sort-drawer]');

    const filterOpenButtons =
      section.querySelectorAll('[data-open-filters]');

    const sortOpenButtons =
      section.querySelectorAll('[data-open-sort]');


    if (!productsGrid) {

      console.warn(
        'Custom Collection: #CustomProductGrid not found.'
      );

      return;

    }


    /* =========================================================
       DRAWERS
    ========================================================= */

    function openDrawer(drawer) {

      if (!drawer) return;

      drawer.classList.add('is-open');

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'custom-collection-drawer-open'
      );

    }


    function closeDrawer(drawer) {

      if (!drawer) return;

      drawer.classList.remove('is-open');

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      const anyOpen =
        section.querySelector(
          '.custom-collection-drawer.is-open'
        );

      if (!anyOpen) {

        document.body.classList.remove(
          'custom-collection-drawer-open'
        );

      }

    }


    filterOpenButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          openDrawer(filterDrawer);

        }
      );

    });


    sortOpenButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          openDrawer(sortDrawer);

        }
      );

    });


    section.querySelectorAll(
      '[data-filter-close]'
    ).forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          closeDrawer(filterDrawer);

        }
      );

    });


    section.querySelectorAll(
      '[data-sort-close]'
    ).forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          closeDrawer(sortDrawer);

        }
      );

    });


    /* =========================================================
       ESCAPE KEY
    ========================================================= */

    function handleEscape(event) {

      if (event.key !== 'Escape') return;

      closeDrawer(filterDrawer);
      closeDrawer(sortDrawer);

    }

    document.addEventListener(
      'keydown',
      handleEscape
    );


    /* =========================================================
       GRID / FEED
    ========================================================= */

    const layoutButtons =
      section.querySelectorAll(
        '.custom-collection-layout-button'
      );


    layoutButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          const layout =
            this.dataset.layout;

          if (!layout) return;


          layoutButtons.forEach(function (btn) {

            btn.classList.remove(
              'is-active'
            );

          });


          this.classList.add(
            'is-active'
          );


          productsGrid.dataset.layout =
            layout;

        }
      );

    });


    /* =========================================================
       FILTER ACCORDIONS
    ========================================================= */

    section.querySelectorAll(
      '.custom-filter'
    ).forEach(function (filter) {

      const summary =
        filter.querySelector('summary');

      const icon =
        filter.querySelector(
          '.custom-filter__icon'
        );

      if (!summary || !icon) return;


      function updateIcon() {

        icon.textContent =
          filter.open ? '−' : '+';

      }


      updateIcon();


      summary.addEventListener(
        'click',
        function () {

          setTimeout(
            updateIcon,
            0
          );

        }
      );

    });


    /* =========================================================
       PRODUCT CARDS
    ========================================================= */

    function getProductCards() {

      return Array.from(
        section.querySelectorAll(
          '.custom-product-card'
        )
      );

    }


    /* =========================================================
       FILTER STATE
    ========================================================= */

    function getSelectedAvailability() {

      const checked =
        section.querySelectorAll(
          '[data-filter-availability]:checked'
        );

      if (!checked.length) {
        return [];
      }

      return Array.from(checked).map(
        function (input) {

          return input.value;

        }
      );

    }


    function getSelectedCategories() {

      const checked =
        section.querySelectorAll(
          '[data-filter-category]:checked'
        );

      return Array.from(checked).map(
        function (input) {

          return input.value;

        }
      );

    }


    function getPriceRange() {

      let min = 0;
      let max = Infinity;


      section.querySelectorAll(
        '[data-price-min]'
      ).forEach(function (input) {

        const value =
          parseFloat(input.value);

        if (!isNaN(value)) {

          min =
            Math.max(
              min,
              value
            );

        }

      });


      section.querySelectorAll(
        '[data-price-max]'
      ).forEach(function (input) {

        const value =
          parseFloat(input.value);

        if (!isNaN(value)) {

          max =
            Math.min(
              max,
              value
            );

        }

      });


      return {
        min: min,
        max: max
      };

    }


    /* =========================================================
       APPLY FILTERS
    ========================================================= */

    function applyFilters() {

      const availability =
        getSelectedAvailability();

      const categories =
        getSelectedCategories();

      const price =
        getPriceRange();


      let visibleCount = 0;


      getProductCards().forEach(
        function (card) {

          const productPrice =
            parseFloat(
              card.dataset.productPrice
            ) || 0;


          const productAvailable =
            card.dataset.productAvailable === 'true';


          const productCategories =
            (
              card.dataset.productCategories ||
              ''
            )
            .split(',')
            .filter(Boolean);


          let visible = true;


          /* AVAILABILITY */

          if (availability.length) {

            const availabilityMatch =
              availability.some(
                function (value) {

                  if (value === 'available') {
                    return productAvailable;
                  }

                  if (value === 'soldout') {
                    return !productAvailable;
                  }

                  return false;

                }
              );


            if (!availabilityMatch) {
              visible = false;
            }

          }


          /* PRICE */

          if (
            productPrice < price.min ||
            productPrice > price.max
          ) {

            visible = false;

          }


          /* CATEGORY */

          if (categories.length) {

            const categoryMatch =
              categories.some(
                function (category) {

                  return productCategories.includes(
                    category
                  );

                }
              );


            if (!categoryMatch) {
              visible = false;
            }

          }


          card.style.display =
            visible ? '' : 'none';


          if (visible) {
            visibleCount++;
          }

        }
      );


      const count =
        section.querySelector(
          '[data-product-count]'
        );


      if (count) {

        count.textContent =
          visibleCount;

      }

    }


    /* =========================================================
       FILTER EVENTS
    ========================================================= */

    section.querySelectorAll(
      '[data-filter-availability], [data-filter-category]'
    ).forEach(function (input) {

      input.addEventListener(
        'change',
        applyFilters
      );

    });


    section.querySelectorAll(
      '[data-apply-price]'
    ).forEach(function (button) {

      button.addEventListener(
        'click',
        applyFilters
      );

    });


    const mobileApply =
      section.querySelector(
        '[data-filter-apply-mobile]'
      );


    if (mobileApply) {

      mobileApply.addEventListener(
        'click',
        function () {

          applyFilters();

          closeDrawer(filterDrawer);

        }
      );

    }


    /* =========================================================
       CLEAR FILTERS
    ========================================================= */

    const clearButton =
      section.querySelector(
        '[data-filter-clear]'
      );


    if (clearButton) {

      clearButton.addEventListener(
        'click',
        function () {

          section.querySelectorAll(
            '[data-filter-availability], [data-filter-category]'
          ).forEach(function (input) {

            input.checked = false;

          });


          section.querySelectorAll(
            '[data-price-min], [data-price-max]'
          ).forEach(function (input) {

            input.value = '';

          });


          getProductCards().forEach(
            function (card) {

              card.style.display = '';

            }
          );


          const count =
            section.querySelector(
              '[data-product-count]'
            );


          if (count) {

            count.textContent =
              getProductCards().length;

          }

        }
      );

    }


    /* =========================================================
       SYNC DESKTOP / MOBILE FILTERS
    ========================================================= */

    section.querySelectorAll(
      '[data-filter-availability], [data-filter-category]'
    ).forEach(function (input) {

      input.addEventListener(
        'change',
        function () {

          const value =
            this.value;

          const type =
            this.hasAttribute(
              'data-filter-availability'
            )
              ? 'availability'
              : 'category';


          let selector;


          if (type === 'availability') {

            selector =
              '[data-filter-availability]';

          } else {

            selector =
              '[data-filter-category]';

          }


          section.querySelectorAll(
            selector
          ).forEach(function (other) {

            if (
              other !== input &&
              other.value === value
            ) {

              other.checked =
                input.checked;

            }

          });

        }
      );

    });


    /* =========================================================
       SORT
    ========================================================= */

    function applySort(value) {

      if (!value) return;


      const url =
        new URL(
          window.location.href
        );


      url.searchParams.set(
        'sort_by',
        value
      );


      window.location.href =
        url.toString();

    }


    const desktopSort =
      section.querySelector(
        '[data-desktop-sort]'
      );


    if (desktopSort) {

      desktopSort.addEventListener(
        'change',
        function () {

          applySort(
            this.value
          );

        }
      );

    }


    section.querySelectorAll(
      '[data-mobile-sort]'
    ).forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          applySort(
            this.dataset.mobileSort
          );

        }
      );

    });


    /* =========================================================
       INFINITE SCROLL
       SEPARATE FROM EVERYTHING ELSE
    ========================================================= */

    initInfiniteScroll(
      section,
      productsGrid,
      applyFilters
    );

  }


  /* =========================================================
     INFINITE SCROLL
  ========================================================= */

  function initInfiniteScroll(
    section,
    productsGrid,
    applyFilters
  ) {

    const loadMoreWrapper =
      section.querySelector(
        '[data-load-more-wrapper]'
      );


    if (!loadMoreWrapper) {

      return;

    }


    if (
      loadMoreWrapper.dataset.initialized === 'true'
    ) {

      return;

    }


    loadMoreWrapper.dataset.initialized =
      'true';


    let loading = false;
    let observer = null;


    async function loadMore() {

      if (loading) return;


      const nextPage =
        loadMoreWrapper.dataset.nextPage;


      if (!nextPage) {

        stop();

        return;

      }


      loading = true;

      loadMoreWrapper.classList.add(
        'is-loading'
      );


      if (observer) {

        observer.unobserve(
          loadMoreWrapper
        );

      }


      try {

        const url =
          new URL(
            nextPage,
            window.location.origin
          );


        /*
         * IMPORTANT:
         * Shopify section rendering.
         */

        url.searchParams.set(
          'section_id',
          section.dataset.sectionId
        );


        console.log(
          '[Custom Collection] Loading:',
          url.toString()
        );


        const response =
          await fetch(
            url.toString(),
            {
              method: 'GET',
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest'
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            'HTTP ' +
            response.status
          );

        }


        const html =
          await response.text();


        if (!html.trim()) {

          throw new Error(
            'Empty Shopify response'
          );

        }


        const parser =
          new DOMParser();


        const parsed =
          parser.parseFromString(
            html,
            'text/html'
          );


        /*
         * Shopify section response can
         * contain the section root.
         */

        const returnedGrid =
          parsed.querySelector(
            '#CustomProductGrid'
          );


        if (!returnedGrid) {

          throw new Error(
            'Returned #CustomProductGrid not found'
          );

        }


        const newCards =
          Array.from(
            returnedGrid.querySelectorAll(
              ':scope > .custom-product-card'
            )
          );


        console.log(
          '[Custom Collection] Products returned:',
          newCards.length
        );


        if (!newCards.length) {

          stop();

          return;

        }


        /*
         * Append products.
         */

        newCards.forEach(
          function (card) {

            productsGrid.appendChild(
              card
            );

          }
        );


        /*
         * Reapply current filters.
         */

        applyFilters();


        /*
         * Find next pagination URL
         * from returned section.
         */

        const returnedLoadMore =
          parsed.querySelector(
            '[data-load-more-wrapper]'
          );


        let newNextPage = null;


        if (returnedLoadMore) {

          newNextPage =
            returnedLoadMore.dataset.nextPage ||
            null;

        }


        /*
         * No more pages.
         */

        if (!newNextPage) {

          stop();

          return;

        }


        /*
         * Prevent same URL loop.
         */

        if (
          newNextPage === nextPage
        ) {

          console.warn(
            '[Custom Collection] Pagination URL did not change.'
          );

          stop();

          return;

        }


        /*
         * Update sentinel.
         */

        loadMoreWrapper.dataset.nextPage =
          newNextPage;


        console.log(
          '[Custom Collection] Next page:',
          newNextPage
        );


      } catch (error) {

        console.error(
          '[Custom Collection] Infinite scroll error:',
          error
        );

        /*
         * IMPORTANT:
         * Don't destroy the sentinel.
         * User can continue scrolling and
         * observer can retry.
         */

      }


      loading = false;

      loadMoreWrapper.classList.remove(
        'is-loading'
      );


      if (observer) {

        observer.observe(
          loadMoreWrapper
        );

      }

    }


    function stop() {

      loading = false;


      if (observer) {

        observer.disconnect();

        observer = null;

      }


      loadMoreWrapper.remove();

    }


    observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              if (
                entry.isIntersecting &&
                !loading
              ) {

                loadMore();

              }

            }
          );

        },
        {
          root: null,
          rootMargin:
            '0px 0px 800px 0px',
          threshold: 0
        }
      );


    observer.observe(
      loadMoreWrapper
    );

  }


  /* =========================================================
     GLOBAL INITIALIZATION
  ========================================================= */

  function initAllCollections() {

    document
      .querySelectorAll(
        '[data-custom-collection]'
      )
      .forEach(function (section) {

        initCustomCollection(
          section
        );

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllCollections
    );

  } else {

    initAllCollections();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.matches(
          '[data-custom-collection]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-custom-collection]'
            );


      if (section) {

        initCustomCollection(
          section
        );

      }

    }
  );



})();